<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full justify-between"
  >
    <proffeo-ui-input
      (debouncedValueChange)="searchValue.set($event)"
      [debounceMs]="300"
      variant="search"
      placeholder="industry-name"
    />
    <proffeo-ui-button
      (clicked)="openSelectProjectIndustryDialog()"
      [fontIcon]="'add'"
      variant="accent"
      text="{{ 'projects-add-new-industry' | translate }}"
    />
    <proffeo-ui-button
      (clicked)="openSelectProjectIndustryDialog()"
      variant="accent"
      fontIcon="add"
      class="button fixed right-5 bottom-3 lg:bottom-10 lg:right-10 flex cursor-pointer"
    ></proffeo-ui-button>
  </div>
  <div class="w-full pt-3 lg:pt-6">
    <div
      [proffeoSpinner]="filteredItems() === undefined"
      proffeoSpinnerSize="lg"
      class="flex min-h-48 w-full flex-col gap-2 lg:overflow-x-auto lg:rounded-md lg:border lg:border-proffeo-border lg:bg-proffeo-surface"
    >
      @if (filteredItems(); as items) {
        <proffeo-project-industries-list
          [projectIndustries]="items"
          [projectId]="activeProjectId()"
        ></proffeo-project-industries-list>
      }
    </div>
  </div>
</proffeo-ui-page-wrapper>
